

export const GetOrganisationAccreditedFields = () : Set<string>=>{
    const fields = new Set<string>();
    fields.add("acronym");
    fields.add("legalName");
    fields.add("name");
    fields.add("hasCompanyNumber");
    fields.add("companyNumber");
    fields.add("hasCharityNumber");
    fields.add("charityNumber");
    fields.add("isOtherUkLegalEntity");
    fields.add("otherLegalEntityType");
    fields.add("isRegisteredInOtherCountry");
    fields.add("otherCountryOfRegistration");
    fields.add("otherCountryIdentifier");
    fields.add("isIndividualOrPartnership");
    fields.add("recognitionNumber");
    fields.add("ofqualRecognisedOnDate");
    fields.add("cceaRecognisedOnDate");
    fields.add("ofqualSurrenderedDate");
    fields.add("ofqualWithdrawnOnDate");
    fields.add("cceaWithdrawnOnDate");
    fields.add("cceaSurrenderedDate");

    return fields;
} 